import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'commonSearch'
})
export class CommonSearchPipe implements PipeTransform {

  transform(arr: any[], searchItem: string, keyToSearch1: string, keyToSearch2?: string): any {
    let transformedList = arr;
    let searchKey = searchItem ? searchItem.toLowerCase() : null;
    if (searchKey) {
      transformedList = transformedList.filter(
        (element: any) => {
          if (keyToSearch1 === 'nationality' && searchItem.length == 1) {
            if (element[keyToSearch1].toLowerCase().charAt(0).includes(searchItem.toLowerCase())) {
              return element;
            }
          } else if (keyToSearch1 === 'timezone') {
            if (element.toLowerCase().includes(searchItem.toLowerCase())) {
              return element;
            }
          } else if (keyToSearch1 === 'tabList') {
            if (element[searchItem]) {
              return element;
            }
          }
          else {
            if (element[keyToSearch1].toLowerCase().includes(searchItem.toLowerCase()) || element[keyToSearch2]?.toString().includes(searchItem)) {
              return element;
            }
          }
        }
      );
    }
    return transformedList;
  }

}
